export default {
  v: '5.3.4',
  fr: 60,
  ip: 0,
  op: 101,
  w: 150,
  h: 150,
  nm: 'BarChart_Preview',
  ddd: 0,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Right',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.25, y: 1 },
                        o: { x: 0.39, y: 0 },
                        n: '0p25_1_0p39_0',
                        t: 10,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -38.676],
                              [35.361, -38.676]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -46.176],
                              [35.361, -46.176]
                            ],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.833, y: 0.833 },
                        o: { x: 0.75, y: 0 },
                        n: '0p833_0p833_0p75_0',
                        t: 24,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -46.176],
                              [35.361, -46.176]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.644, 38.661],
                              [35.365, 38.661]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 42 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 43,
          st: -19,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Middle',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.25, y: 1 },
                        o: { x: 0.39, y: 0 },
                        n: '0p25_1_0p39_0',
                        t: 5,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.36, -2.926], [9.361, -2.926]],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [9.361, 38.676],
                              [-9.36, 38.676],
                              [-9.36, -10.426],
                              [9.361, -10.426]
                            ],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.833, y: 0.833 },
                        o: { x: 0.75, y: 0 },
                        n: '0p833_0p833_0p75_0',
                        t: 19,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [9.361, 38.676],
                              [-9.36, 38.676],
                              [-9.36, -10.426],
                              [9.361, -10.426]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.361, 38.645], [9.36, 38.645]],
                            c: true
                          }
                        ]
                      },
                      { t: 37 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 38,
          st: -24,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Left',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.25, y: 1 },
                        o: { x: 0.39, y: 0 },
                        n: '0p25_1_0p39_0',
                        t: 1,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -17.226],
                              [-16.64, -17.226]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -24.726],
                              [-16.64, -24.726]
                            ],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.833, y: 0.833 },
                        o: { x: 0.75, y: 0 },
                        n: '0p833_0p833_0p75_0',
                        t: 15,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -24.726],
                              [-16.64, -24.726]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.349, 38.634],
                              [-16.628, 38.634]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 33 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 3',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 34,
          st: -28,
          bm: 0
        }
      ]
    },
    {
      id: 'comp_1',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'RIght',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.2, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p2_1_0p167_0p167',
                        t: 11,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.644, 38.661],
                              [35.365, 38.661]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -38.33],
                              [35.361, -38.33]
                            ],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.19, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p19_1_0p167_0p167',
                        t: 29,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -38.33],
                              [35.361, -38.33]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [35.361, 38.676],
                              [16.64, 38.676],
                              [16.64, -38.676],
                              [35.361, -38.676]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 53 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 11,
          op: 56,
          st: -8,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Middle',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.2, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p2_1_0p167_0p167',
                        t: 6,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.361, 38.645], [9.36, 38.645]],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.36, -2.739], [9.361, -2.739]],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.19, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p19_1_0p167_0p167',
                        t: 24,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.36, -2.739], [9.361, -2.739]],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [[9.361, 38.676], [-9.36, 38.676], [-9.36, -2.926], [9.361, -2.926]],
                            c: true
                          }
                        ]
                      },
                      { t: 48 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 6,
          op: 56,
          st: -13,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Left',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [75, 75, 0], ix: 2 },
            a: { a: 0, k: [75, 75, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.2, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p2_1_0p167_0p167',
                        t: 2,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.349, 38.634],
                              [-16.628, 38.634]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -16.975],
                              [-16.64, -16.975]
                            ],
                            c: true
                          }
                        ]
                      },
                      {
                        i: { x: 0.19, y: 1 },
                        o: { x: 0.167, y: 0.167 },
                        n: '0p19_1_0p167_0p167',
                        t: 20,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -16.975],
                              [-16.64, -16.975]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                            v: [
                              [-16.64, 38.676],
                              [-35.361, 38.676],
                              [-35.361, -17.226],
                              [-16.64, -17.226]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 44 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 3',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [75.002, 74.252], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 2,
          op: 56,
          st: -17,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'BarChart_AnimOff',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [75, 75, 0], ix: 2 },
        a: { a: 0, k: [75, 75, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      w: 150,
      h: 150,
      ip: 56,
      op: 101,
      st: 56,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: 'BarChart_AnimOn',
      refId: 'comp_1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [75, 75, 0], ix: 2 },
        a: { a: 0, k: [75, 75, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      w: 150,
      h: 150,
      ip: 0,
      op: 56,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
